import Route from "route-parser";

export const pathWithoutTrailingSlash = (pathname: string): string => {
  if (pathname.length > 1 && pathname.slice(-1) === "/") {
    return pathname.slice(0, -1);
  }

  return pathname;
};

export const routeMatches = (spec: string, path = window.location.pathname) => {
  const pathname = pathWithoutTrailingSlash(path);
  return new Route(spec).match(pathname);
};

export const cleanQueryParams = (
  params: Record<string, unknown>,
): URLSearchParams => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const obj: Record<string, any> = {};
  return new URLSearchParams(
    Object.entries(params).reduce((acc, [key, value]) => {
      if (
        value !== undefined &&
        (typeof value === "string" ||
          typeof value === "number" ||
          typeof value === "boolean" ||
          value === null ||
          Array.isArray(value))
      ) {
        acc[key] = value;
      }
      return acc;
    }, obj),
  );
};

let routed = false;

const route = (
  spec: string,
  cb: (prop: { [x: string]: string }) => unknown,
) => {
  if (routed) return;

  const result = routeMatches(spec);

  if (result) {
    routed = true;
    cb(result);
  }
};

export default route;
